import PropTypes from 'prop-types';

export const paddingLevels = {
  0: 'p-x0',
  1: 'p-x1',
  2: 'p-x2',
  3: 'p-x3',
  4: 'p-x4',
  5: 'p-x5',
  6: 'p-x6',
  7: 'p-x7',
  8: 'p-x8',
  9: 'p-x9',
  10: 'p-x10',
  11: 'p-x11',
  12: 'p-x12'
} as const;

export type PaddingLevel = keyof typeof paddingLevels;
export type PaddingLevelClass = (typeof paddingLevels)[PaddingLevel];

export const paddingLevelPropType = PropTypes.oneOf(
  Object.keys(paddingLevels).map(Number) as PaddingLevel[]
);
